import { BaseModel } from "sjs-base-model";
import SearchAnagCqCrmModelElement from "./SearchAnagCqCrmModelElement";

export default class SearchAnagCqCrmModel extends BaseModel {
    readonly data: SearchAnagCqCrmModelElement[] = [];

    constructor(data: Partial<SearchAnagCqCrmModel>) {
        super();

        this.update(data);
    }
}
